// generated
export const GATEWAY_VERSION = "0.13.0-beta.0";
